import { useState } from 'react';

import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import authAxios from '../../components/authAxios';

import { TextField } from "@mui/material";
import {Button} from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

// import { Modal, Select } from 'antd';
import { Select, Modal, Divider, message } from 'antd';
import {Button as AntButton} from 'antd';
import {PlusCircleOutlined } from '@ant-design/icons';
import NumberFormat from "react-number-format";
import { RELATIONSHIPS } from '../../constants';


const CustomerRelatedParties = ({ addRelatedParty, isModalOpen, setIsModalOpen, tableData }) => {
    const queryClient = useQueryClient();

    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [idNumber, setIdNumber] = useState('');
    const [relationship, setRelationship] = useState(null);
    const relationshipName = RELATIONSHIPS.find((r) => r.value === relationship);

    const contactType = '10'; // Default to "Individual"

    // const [dropdownOpen, setDropdownOpen] = useState(false);
    // const [isCreateOpen, setIsCreateOpen] = useState(false);

    const [mode, setMode] = useState('select');   // 'select' | 'create'
    const category = "CUSTOMER_RELATED_PARTY";


    const { data: contacts = [] } = useQuery({
        queryKey: ['contacts'],
        queryFn: async () => {
            const response = await authAxios.get(`/contacts`);
            return response.data;
        },
    });

    const [contactId, setContactId] = useState();
    const selectedContact = contacts.find((c) => c.id === contactId);

    const resetForm = () => {
        setContactId(undefined); //Antd treats the empty string as a real selected value
        setRelationship(undefined); //Antd treats the empty string as a real selected value
        setName('');
        setMobile('');
        setEmail('');
        setIdNumber('');
        // any other select-mode fields, e.g. setAmount(undefined);
    };

    const { mutate: createRelatedParty, isLoading: isSaving } = useMutation({
        mutationFn: async () => {
            const response = await authAxios.post('/contacts/', {
                client,
                type: contactType,
                name,
                telephone: mobile,
                email,
                id_number: idNumber,
                user,
                category
            },
            {headers: {
                'Content-Type': 'multipart/form-data'
            }}
        );
            return response.data;
        },
        onSuccess: (created) => {
            // keep the contacts list fresh for the select dropdown
            queryClient.invalidateQueries({ queryKey: ['contacts'] });

            // add straight to the table using the created Contact
            addRelatedParty({
                contactId: created.id,
                name: created.name,
                phone: created.telephone,
                relationship: relationship,
                relationshipName: relationshipName?.label || relationship
            });

            // reset + close, skip select mode entirely
            // setName(''); setMobile(''); setEmail(''); setIdNumber(''); setRelationship(''); 
            resetForm();
            setMode('select');
            setIsModalOpen(false);
        },
        onError: () => {
            message.error('Could not save next of kin. Please try again.');
        },
    });

    const handleCancel = () => {
        setIsModalOpen(false);
        resetForm();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedContact) return;

        addRelatedParty({
            contactId: selectedContact.id,
            name: selectedContact.name,
            phone: selectedContact.telephone,
            relationship: relationship,
            relationshipName: relationshipName?.label || relationship
        });
        resetForm();
        setIsModalOpen(false);
    };


    return (
        <>
        <div className="inline-table-container product-details-container">
            <table className="styled-table">
                <thead>
                    <tr >
                        <th>#</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Relationship</th>
                        <th style={{ textAlign: 'center', padding: 0 }}></th>
                    </tr>
                </thead>
                {tableData && tableData.map((rowData, index) => (
                    <tbody key={index}>
                        <tr>
                            <td>{index + 1}</td>
                            <td>{rowData.name}</td>
                            <td>{rowData.phone}</td>
                            <td>{rowData.relationshipName}</td>
                            <td style={{ textAlign: 'center', padding: 0 }}>
                                <IconButton 
                                    size="small">
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </td>
                        </tr>
                    </tbody>
                ))}
            </table>
        </div>

        <div className="AddRow">
            <Button
                id="AddRowButton"
                onClick={() => {
                    setIsModalOpen(true)}
                }
                variant="outlined" 
                size="small"
                startIcon={<AddCircleOutlineIcon />}
            >
                Next of Kin
            </Button>
        </div>
 

        <Modal
            className="dashboard-modal"
            title={mode === 'select' ? 'Add Next of Kin' : 'New Next of Kin'}
            visible={isModalOpen}
            onCancel={handleCancel}
            footer={
                mode === 'select' ? (
                    <>
                        <AntButton onClick={handleCancel}>Cancel</AntButton>
                        <AntButton type="primary" onClick={handleSubmit}>OK</AntButton>
                    </>
                ) : (
                    <>
                        <AntButton onClick={() => setMode('select')}>Back</AntButton>
                        <AntButton type="primary" loading={isSaving} onClick={() => createRelatedParty()}>Save</AntButton>
                    </>
                )
            }
        >

            <div className="dashboard-form">
                <div style={{ display: mode === 'select' ? 'block' : 'none' }}>
                    <Select
                        showSearch
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Next of Kin"

                        value={contactId}
                        onChange={setContactId}
                        optionFilterProp="label"
                        options={contacts.map((c) => ({ value: c.id, label: c.name }))}
                        dropdownRender={(menu) => (
                            <>
                                {menu}
                                <Divider style={{ margin: '8px 0' }} />
                                <AntButton
                                    type="text"
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => setMode('create')}
                                    style={{
                                        width: '100%',
                                        textAlign: 'left',
                                        padding: '5px 12px',
                                        height: 'auto',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        margin: '4px 0',
                                        color: '#1890ff'
                                    }}
                                >
                                    <PlusCircleOutlined style={{ fontSize: 16 }} />
                                    <span style={{ marginLeft: 0 }}>New Next of Kin</span>
                                </AntButton>
                            </>
                        )}
                    />

                    <TextField
                        className="custom-input"
                        value={selectedContact?.telephone ?? ''}
                        label="Telephone"
                        variant="outlined"
                        fullWidth
                        disabled
                    />

                    <Select
                        className="custom-input"
                        showSearch
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Relationship"
                        value={relationship}
                        onChange={setRelationship}
                        optionFilterProp="label"
                        options={RELATIONSHIPS}
                    />
                </div>
            </div>
  

            <div className="dashboard-form" style={{ display: mode === 'create' ? 'block' : 'none' }}>
                <TextField className="custom-input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    label="Name" 
                    variant="outlined" 
                    fullWidth
                    required
                />

                <NumberFormat 
                    value={mobile}
                    onValueChange={({ value }) => setMobile(value)}   // "254712345678"
                    className="custom-input"
                    fullWidth
                    label="Telephone" 
                    variant="outlined" 
                    customInput={TextField}
                    format="### (###) ######" mask="_"
                />
                <TextField className="custom-input"
                    value={idNumber}
                    onChange={(e) => setIdNumber(e.target.value)}
                    label="ID/Passport Number" 
                    variant="outlined" 
                    fullWidth
                    required
                /> 

                <Select
                    className="custom-input"
                    showSearch
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Relationship"
                    value={relationship}
                    onChange={setRelationship}
                    optionFilterProp="label"
                    options={RELATIONSHIPS}
                />
            </div>
        </Modal>

        </>

    );
};

export default CustomerRelatedParties;
